/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const enum PlanId {
  LITE = 'bd16e3c8-3da0-11e6-bce3-54ee7514918e',
  STANDARD = 'd9c80e46-3195-11e6-a92b-54ee7514918e',
  PLUS = 'f0a3dd47-b693-4d73-a8df-aa6baf07a933',
  PREMIUM = '45333bd7-79f5-475f-9b14-9fe99734592a',
  PREMIUM_USERBASED = '068f8a20-8b27-4049-91fe-a3ff5f505352',
  PLUS_TRIAL = 'a7c3614c-c75f-4c45-85e4-0626492539d3',
  PLUS_ZERORATED = '83b06f49-0004-4b76-8480-8a46bd33a0dc',
  PREMIUM_USERBASED_ZERORATED = 'fe1aeb63-1cff-40df-a8fe-f060b6730ce1',
  ENTERPRISE = '4ae68471-07c3-4f02-a49d-d19cb4a29ac9',
  ENTERPRISEDATAISOLATION = 'bfb69661-13fa-4213-b414-6ef29745abcd'
}

// See https://github.ibm.com/watson-engagement-advisor/wea-conversational-store/blob/develop/lib/config/environment/index.js#L381-L392
export const enum PlanName {
  FREE = 'free',
  DEV_ONLY_PREMIUM = 'dev_only-premium',
  LITE = 'lite',
  STANDARD = 'standard',
  PLUS = 'plus',
  PREMIUM = 'premium',
  PREMIUM_USERBASED = 'premium_userbased',
  PLUS_TRIAL = 'plus_trial',
  PLUS_ZERORATED = 'plus_zerorated',
  PREMIUM_USERBASED_ZERORATED = 'premium_userbased_zerorated',
  ENTERPRISE = 'enterprise',
  ENTERPRISE_DATA_ISOLATION = 'enterprisedataisolation'
}

/**
 * The names of the plans supported by watsonx Orchestrate.
 * Based on their expected service level, they map to one of the WXA plans.
 */
export const enum WxoPlanName {
  // Corresponds to WXA's Plus plan.
  ESSENTIALS = 'essentials',
  // Corresponds to WXA's Enterprise plan.
  STANDARD = 'standard',
  // Corresponds to WXA's Enterprise with Data Isolation plan.
  PREMIUM = 'premium'
}

/**
 * How the plan usage is metered for billing purposes.
 */
export const enum PlanMetering {
  // Billing is done based on monthly average users.
  MAU = 'mau',
  // Billing is done based on number of messages.
  MESSAGES = 'messages'
}

export type TrialData = Partial<{
  start_date: string;
  end_date: string;
  extensions: number;
}>;
